import React from 'react';
import PatternLoader from 'react-image';
import PropTypes from 'prop-types';

import ImagePlaceholder from '../ImagePlaceholder';

const Pattern = ({ src }) => (<PatternLoader
    src={src}
    loader={<ImagePlaceholder />}
    unloader={<ImagePlaceholder />}
/>);

Pattern.propTypes = {
    src: PropTypes.string,
};

Pattern.defaultProps = {
    src: '',
};

export default Pattern;



// WEBPACK FOOTER //
// ./src/components/image/Pattern.js